// extracted by mini-css-extract-plugin
module.exports = {"container":"PromptsSelector_container__cD4cP","scroll":"PromptsSelector_scroll__cADvl","button":"PromptsSelector_button__y_crS"};